import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import FloatingCard from './FloatingCard';

const styles = theme => ({
  card: {
    display: 'inline-block',
    height: '550px',
    width: '285px',
    padding: 'unset',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
});

const CalculatorCard = (props) => {
  const { classes, children } = props;
  return (
    <FloatingCard className={classes.card}>
      <div className={classes.details}>
        { children }
      </div>
    </FloatingCard>
  );
};

CalculatorCard.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  children: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(styles, { withTheme: true })(CalculatorCard);

